import {
  Autocomplete,
  Chip,
  Grid,
  TextField,
  Typography
} from '@material-ui/core'
import BetterPropTypes from 'better-prop-types'
import PropTypes from 'prop-types'
import { Matter } from 'src/types/matter'
import { validateOptions } from 'src/utils/communications'

const AutoComplete = ({ ...props }) => {
  const { options, defaultValue, label, onChange, md = 6 } = props
  const isMatter = label === 'Matter'
  const isLiveNotesMatter = isMatter && md === 12

  return (
    <Grid item md={isMatter ? 12 : md} xs={12}>
      <Autocomplete
        {...props}
        multiple={!isMatter}
        disableCloseOnSelect
        options={options}
        defaultValue={defaultValue}
        getOptionLabel={(option: Matter) => {
          if (!isMatter) return option.displayName
          return `${option.displayName} - ${option.externalMatterIds.clio}`
        }}
        getOptionSelected={(option, value) => validateOptions(option, value)}
        renderOption={(option) => {
          // @ts-ignore
          return (
            <Typography sx={{ cursor: 'pointer', padding: 1 }} {...option}>
              {
                // @ts-ignore
                option.key.split('|||')[0]
              }
            </Typography>
          )
        }}
        renderTags={(value: any[], getTagProps) =>
          value.map((option: any, index: number) => {
            if (!option) return ''
            return (
              <Chip
                variant="outlined"
                label={option.displayName.split('|||')[0]}
                {...getTagProps({ index })}
              />
            )
          })
        }
        onChange={(e, value) => {
          if (!onChange) return null
          if (!isMatter || isLiveNotesMatter) return onChange(value, label)
          return null
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            data-id={label}
          />
        )}
      />
    </Grid>
  )
}

AutoComplete.propTypes = {
  options: BetterPropTypes.array.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  label: BetterPropTypes.string.isRequired,
  onChange: BetterPropTypes.func.isOptionalButNotNull,
  md: BetterPropTypes.number
}

export default AutoComplete
